import React from 'react';
import { GroupByMode, TaskGroupBy } from 'shared/types/sorting-mode';

import { CompletedDateGroupingTasksList } from './components/completed-date-grouping-tasks-list';
import { DayPartGroupingTasksList } from './components/day-part-grouping-tasks-list';
import { DeadlineDeadlineGroupingTasksList } from './components/deadline-deadline-grouping-tasks-list';
import { DeadlineGroupingTasksList } from './components/deadline-grouping-tasks-list';
import { GoalGroupingTasksList } from './components/goal-grouping-tasks-list';
import { LifeAreaGroupingTasksList } from './components/life-area-grouping-tasks-list';
import { NoGroupingTasksList } from './components/no-grouping-tasks-list';
import { PriorityGroupingTasksList } from './components/priority-grouping-tasks-list';
import { SectionGroupingTasksList } from './components/section-grouping-tasks-list';
import { TagGroupingTasksList } from './components/tag-grouping-tasks-list';
import { TypeGroupingTasksList } from './components/type-grouping-tasks-list';
import { GroupedListProps, GroupSetting } from './types';

export const groupByLists: Record<TaskGroupBy, React.FC<GroupedListProps>> = {
  [GroupByMode.None]: NoGroupingTasksList,
  [GroupByMode.LifeArea]: LifeAreaGroupingTasksList,
  [GroupByMode.Goal]: GoalGroupingTasksList,
  [GroupByMode.DayPart]: DayPartGroupingTasksList,
  [GroupByMode.Type]: TypeGroupingTasksList,
  [GroupByMode.Priority]: PriorityGroupingTasksList,
  [GroupByMode.Deadline]: DeadlineGroupingTasksList,
  [GroupByMode.DeadlineDeadline]: DeadlineDeadlineGroupingTasksList,
  [GroupByMode.Tag]: TagGroupingTasksList,
  [GroupByMode.Section]: SectionGroupingTasksList,
  [GroupByMode.CompletedDate]: CompletedDateGroupingTasksList,
};

const defaultGroupSetting: GroupSetting = {
  showEmptyGroups: false,
};

export const defaultGroupSettings: Record<TaskGroupBy, GroupSetting> = {
  [GroupByMode.None]: defaultGroupSetting,
  [GroupByMode.LifeArea]: defaultGroupSetting,
  [GroupByMode.Goal]: defaultGroupSetting,
  [GroupByMode.DayPart]: defaultGroupSetting,
  [GroupByMode.Type]: defaultGroupSetting,
  [GroupByMode.Priority]: defaultGroupSetting,
  [GroupByMode.Deadline]: defaultGroupSetting,
  [GroupByMode.DeadlineDeadline]: defaultGroupSetting,
  [GroupByMode.Tag]: defaultGroupSetting,
  [GroupByMode.Section]: defaultGroupSetting,
  [GroupByMode.CompletedDate]: defaultGroupSetting,
};
